import homeContent from '../../../content/pages/home.json';

const slides = homeContent.slides.map((slide, index) => ({
    id: index + 1,
    ...slide,
}));

export default slides;
